import * as definitions from '@database/common-schema/definitions';
export const AssemblerTextParagraphSubdocumentSchema = {
    title: 'IAssemblerTextParagraphSubdocument',
    type: 'object',
    schemaType: 'block',
    additionalProperties: false,
    properties: {
        type: { enum: ['TEXT'] },
        content: { type: 'string' },
        isHighlightBlock: { type: 'boolean' },
    },
    required: ['type', 'content'],
};
export const AssemblerImageParagraphSubdocumentSchema = {
    title: 'IAssemblerImageParagraphSubdocument',
    type: 'object',
    schemaType: 'block',
    additionalProperties: false,
    properties: {
        type: { enum: ['IMAGE'] },
        title: { type: 'string' },
        alt: { type: 'string' },
        caption: { type: 'string' },
        source: { type: 'string', description: 'Image URL' },
        credits: { type: 'string' },
        height: { type: 'number' },
        width: { type: 'number' },
        ctfImageUuid: {
            ...definitions.uuid,
            description: 'If image was already uploaded to CTF, this is its UUID in CTF images database',
        },
        isImportableInVibe: {
            type: 'boolean',
            description: 'Indicates whether the image is eligible for import into Vibe. Used only for agencies',
        },
    },
    required: ['type', 'source'],
};
export const AssemblerQuoteParagraphSubdocumentSchema = {
    title: 'IAssemblerQuoteParagraphSubdocument',
    additionalProperties: false,
    schemaType: 'block',
    properties: {
        type: { enum: ['QUOTE'] },
        author: { type: 'string' },
        quote: { type: 'string' },
    },
    required: ['type', 'quote'],
};
export const AssemblerPartnerParagraphSubdocumentSchema = {
    title: 'IAssemblerPartnerParagraphSubdocument',
    additionalProperties: false,
    schemaType: 'block',
    properties: {
        type: { enum: ['PARTNER'] },
        content: { type: 'string' },
        isHighlightBlock: { type: 'boolean' },
    },
    required: ['type', 'content'],
};
export const AssemblerCtaButtonParagraphSubdocumentSchema = {
    title: 'IAssemblerCtaButtonParagraphSubdocument',
    type: 'object',
    additionalProperties: false,
    schemaType: 'block',
    properties: {
        type: { enum: ['CTA_BUTTON'] },
        ctaButtonUuid: definitions.uuid,
        hasAffiliate: { type: 'boolean', default: false },
    },
    required: ['type', 'ctaButtonUuid'],
};
export const AssemblerSocialParagraphSubdocumentSchema = {
    title: 'IAssemblerSocialParagraphSubdocument',
    type: 'object',
    schemaType: 'block',
    additionalProperties: false,
    properties: {
        type: { enum: ['SOCIAL'] },
        content: { type: 'string' },
        socialName: { type: 'string' },
        postId: { type: 'string' },
        accountName: { type: 'string' },
        postUrl: { type: 'string' },
        embedType: { type: 'string' },
    },
    required: ['type', 'content', 'socialName', 'postId'],
};
export const AssemblerParagraphSubdocumentSchema = {
    title: 'IAssemblerParagraphSubdocument',
    type: 'object',
    schemaType: 'subdocument',
    oneOf: [
        AssemblerTextParagraphSubdocumentSchema,
        AssemblerImageParagraphSubdocumentSchema,
        AssemblerQuoteParagraphSubdocumentSchema,
        AssemblerPartnerParagraphSubdocumentSchema,
        AssemblerCtaButtonParagraphSubdocumentSchema,
        AssemblerSocialParagraphSubdocumentSchema,
    ],
};
//# sourceMappingURL=assembler.paragraph.block.schema.js.map